import api from './api';

export async function fetchDashboardHeaderData() {
  const response = await api.get('/get-dashboard-header-data');
  return response?.data?.dataset?.data || {};
}
